import React from 'react'
import { OnSchedUtils } from '../../../../utils'


const NoAvailableTimes = ({ element }) => 
  <div 
    className='AvailableTimes no-available-times onsched-dark-color'
  >
    { OnSchedUtils.Internationalize(element, 'consumer_availability_none') }
  </div>

export default NoAvailableTimes;